<template>
  <div
    class="course-detail"
    :class="{
      'electron-course-detail': isElectron,
      'h5-course-detail': isH5,
    }"
    v-loading.fullscreen.lock="pageLoading"
    element-loading-text="进入教室中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255,255,.6)"
  >
    <p v-if="!isElectron" class="back-area" @click="goback()">
      <img src="../../../assets/images/back-icon.png" alt="" /><span>返回</span>
    </p>
    <div class="page-cont-wrap">
      <!-- 课程信息 -->
      <div class="course-crad">
        <div class="cover-wrap">
          <img
            v-if="courseInfo.cover_url"
            class="cover"
            :src="processImageUrl(courseInfo.cover_url, 640)"
            alt=""
          />
        </div>

        <div class="course-info">
          <div class="info-top">
            <div class="name-wrap">
              <p class="name">
                {{ courseInfo.course_name }}
              </p>
              <el-popover
                v-model="isShowShare"
                placement="bottom-start"
                trigger="click"
                popper-class="share-popover"
                @after-leave="selectShare = {}"
                @show="onShowSharePopover"
              >
                <button
                  v-if="!isWeChat && !isQQ"
                  slot="reference"
                  class="share-icon"
                  v-preventReClick
                >
                  <img src="../../../assets/images/share-icon.png" alt="" />
                </button>
                <div class="share-box">
                  <div class="share-list" v-if="!selectShare.type">
                    <div
                      class="share-item copy-item"
                      @click="handleCopyPageUrl"
                    >
                      <img
                        src="../../../assets/images/product-details/link.png"
                        alt=""
                      />
                      <span>复制链接</span>
                    </div>
                    <div class="divider"></div>
                    <div class="share-item" @click="handleShare('wechat')">
                      <img
                        src="../../../assets/images/product-details/wx.png"
                        alt=""
                      />
                      <span>微信</span>
                    </div>
                    <div class="share-item" @click="handleShare('circle')">
                      <img
                        src="../../../assets/images/product-details/wx-circle.png"
                        alt=""
                      />
                      <span>朋友圈</span>
                    </div>
                    <div class="share-item" @click="handleShare('QQ')">
                      <img
                        src="../../../assets/images/product-details/QQ.png"
                        alt=""
                      />
                      <span>QQ</span>
                    </div>
                    <div class="share-item" @click="handleShare('space')">
                      <img
                        src="../../../assets/images/product-details/QQ-space.png"
                        alt=""
                      />
                      <span>QQ空间</span>
                    </div>
                    <div class="share-item" @click="handleShare('weibo')">
                      <img
                        src="../../../assets/images/product-details/weibo.png"
                        alt=""
                      />
                      <span>微博</span>
                    </div>
                    <div
                      class="share-item"
                      @click="handleShare('xhs')"
                      v-if="isH5"
                    >
                      <img
                        src="../../../assets/images/product-details/xhs.png"
                        alt=""
                      />
                      <span>小红书</span>
                    </div>
                  </div>
                  <div class="share-content" v-else>
                    <div class="title">
                      <img
                        src="../../../assets/images/product-details/back.png"
                        alt=""
                        @click="handleShareBack"
                      />
                      <span>分享到{{ selectShare.title }}</span>
                    </div>
                    <div class="qrcode-box">
                      <create-qr-code
                        ref="qrCode"
                        :url="courseDetailUrl"
                        :logo-url="logoUrl"
                        :canvas-width="140"
                        :canvas-height="140"
                        @create-qr-code="getQrCodeUrl"
                      />
                    </div>
                    <div class="tips">{{ selectShare.content }}</div>
                  </div>
                </div>
              </el-popover>
            </div>
            <p class="course-status">
              <span class="status0" v-if="courseInfo.study_status === 0"
                >未开始</span
              >
              <span class="status1" v-else-if="courseInfo.study_status === 1"
                >进行中</span
              >
              <span class="status2" v-else-if="courseInfo.study_status === 2"
                >已完成</span
              >
            </p>
          </div>
          <div class="info-bottom">
            <p class="lesson-num">
              课时数：<span>{{ courseInfo.lesson_count }}课时</span>
            </p>
            <div class="card-operate-wrap">
              <p class="time">
                课程有效期： {{ dealValidityType(courseInfo) }}
              </p>
              <div class="card-operate">
                <button
                  v-if="haveLastLearningRecord"
                  class="study-btn"
                  @click="jumpVideoPlay"
                >
                  继续学习
                </button>
                <button
                  v-if="courseInfo.live_state === 1"
                  class="living-btn"
                  @click="goLiveRoom"
                >
                  <img src="../../../assets/images/living-white.gif" alt="" />
                  进入直播
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-cont-wrap">
        <div class="course-lesson-cont">
          <ul class="tabs-wrap">
            <li
              @click="activeName = item.key"
              v-for="item in tabList"
              :key="item.key"
              :class="{ active: item.key === activeName }"
            >
              {{ item.name }}
            </li>
          </ul>
          <!-- 单元信息 -->
          <lesson-list
            :lastStudyLesson="lastStudyLesson"
            key="course"
            v-if="activeName === 'course'"
            :unitList="courseInfo.unit_list || []"
            @pageLoading="handlePageLoading"
          />
          <!-- 文件   -->
          <file v-if="activeName === 'file'"></file>
          <!-- 私教课 -->
          <lesson-list
            key="private"
            v-if="activeName === 'private'"
            :unitList="courseInfo.private_unit_list || []"
            ::lastStudyLesson="lastStudyLesson"
            @pageLoading="handlePageLoading"
          />
        </div>
        <div class="org-cont">
          <!-- 机构信息 -->
          <OrgCard class="org-card" :orgInfo="orgInfo" />
          <!-- 下载区域 -->
          <DownloadArea v-if="!isElectron" />
          <!-- 推荐课程 -->
          <RecommendCourse
            v-if="orgRecommendCourse.id"
            :courseInfo="orgRecommendCourse"
          />
        </div>
      </div>
    </div>
    <poster
      ref="poster"
      :course-info="courseInfo"
      @getPosterUrl="getPosterUrl"
    />
    <!-- 课程-小助手 -->
    <CourseHelper
      v-if="courseInfo.assistant && courseInfo.assistant.id"
      :assistant="courseInfo.assistant || {}"
      :courseId="course_id"
    />
  </div>
</template>

<script>
import { getTeacherToken, getUserToken } from "@saas/service-api/src/live-list";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { getCoursesState, getCourseList } from "@saas/service-api/src/course";
import {
  getOrganizationHome,
  getOrganization,
} from "@saas/service-api/src/organization";
import RecommendCourse from "./components/RecommendCourse";
import DownloadArea from "./components/DownloadArea";
import OrgCard from "@saas/pages/src/search-result/components/OrgCard";
import LessonList from "./components/LessonList";
import File from "./components/File";
import {
  isHXApp,
  copyPageUrl,
  clipboard,
  isH5,
  isWeChat,
  isQQ,
  CourseHelper,
  joinLiveRoom,
  processImageUrl,
} from "@saas/components/src";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import {
  getLessonDetail,
  getCourseDetail,
} from "@saas/service-api/src/learning-center";
import CreateQrCode from "@saas/components/src/components/CreateQrCode";
import Poster from "@saas/components/src/components/Poster";
import shareSdk from "@saas/components/src/utils/share";
import courseQuickBar from "@saas/components/src/mixins/courseQuickBar";
export default {
  mixins: [courseQuickBar],
  data: function () {
    return {
      orgInfo: {},
      orgRecommendCourse: {}, //机构下的推荐课程
      pageLoading: false,
      isHXApp: isHXApp(),
      isH5: isH5(),
      moment,
      course_id: "",
      courseInfo: {},
      activeName: "course",
      tabList: [
        { name: "课程", key: "course" },
        { name: "文件", key: "file" },
      ],
      copyPageUrl,
      isElectron: window.isElectron,
      selectShare: {
        type: "",
      },
      courseDetailUrl:
        process.env.VUE_APP_SAAS_WEB_URL +
        "/product-detail/" +
        this.$route.params.id,
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      isShowShare: false,
      qrCodeUrl: "",
      posterUrl: "",
      isWeChat: isWeChat(),
      isQQ: isQQ(),
      lastStudyLesson: {}, //上次学到
    };
  },
  created() {
    this.course_id = this.$route.params.id;
    this.apiGetCourseDetail();
  },
  mounted() {
    this.$nextTick(() => {
      // this.$refs.poster.createPoster();
    });
  },
  beforeDestroy() {
    if (this.courseInfo?.assistant?.id) {
      EventBus.$emit("hideCourseHelper", false);
    }
  },
  methods: {
    processImageUrl,
    async goLiveRoom() {
      let { lesson_id, unit_id } = this.courseInfo.livingLessonInfo || {};
      let course_id = this.course_id;
      this.$saasLoadingShow();
      let params = {
        course_id,
        lesson_id,
      };
      let res = await getLessonDetail(params);
      let fn = getUserToken;
      if (res?.code === 1) {
        const isNewLive = res.data?.is_new_live;
        let { is_teacher, mode } = res.data;
        if (is_teacher) {
          fn = getTeacherToken;
        }
        fn(params).then((res) => {
          if (res.code === 1) {
            let {
              room_id = "",
              token = "",
              user_id = "",
              risk_control_switch,
              is_teacher = false,
              risk_control_config = {},
              is_lesson_teacher,
              is_lesson_assistant,
            } = res.data;
            const disableRecord =
              risk_control_switch === 1 &&
              risk_control_config.recording_screen_switch === 1
                ? 1
                : 0;
            let liveRoomParam = {
              classid: room_id,
              userid: user_id,
              courseid: course_id,
              lessonid: lesson_id,
              token: token,
              disableRecord,
              mode,
              isNewLive: isNewLive,
              isTeacher: is_lesson_teacher,
              isAssistant: is_lesson_assistant,
            };
            joinLiveRoom(liveRoomParam);
          } else if (res.code === 40007) {
            // 开启网页防火墙
            this.$router.replace("/firewall/" + course_id);
            this.$saasLoadingClose();
          } else {
            this.$message.error(res.message);
            this.$saasLoadingClose();
          }
        });
      } else {
        this.$message.error(res.message);
        this.$saasLoadingClose();
      }
    },
    jumpVideoPlay() {
      let { lesson_id, unit_id } = this.lastStudyLesson || {};
      if (!lesson_id) {
        this.$showToast("暂无上次学习记录");
        return;
      }
      this.$router.push({
        path: `/video-play/${this.course_id}/${unit_id}/${lesson_id}`,
      });
    },
    apiGetOrganizationHome(org_id) {
      let params = {
        org_id,
        module_type: 4,
      };
      getOrganizationHome(params).then((res) => {
        if (res.code === 1) {
          if (res?.data?.length) {
            let orgRecommendCourse = {};
            for (let index = 0; index < res.data.length; index++) {
              const item = res.data[index];
              if (item?.content_list?.length) {
                orgRecommendCourse =
                  item?.content_list.find((course) => {
                    return course?.id !== this.course_id;
                  }) || {};
              }
              if (orgRecommendCourse?.id) {
                break;
              }
            }
            if (orgRecommendCourse?.id) {
              // 获取课程活动信息
              getCourseList({ course_id: orgRecommendCourse?.id }).then(
                (res) => {
                  if (res.code === 1) {
                    // 获取课程状态
                    this.orgRecommendCourse = res?.data?.list[0] || {};
                    this.apiGetCourseState(
                      orgRecommendCourse?.id,
                      "orgRecommendCourse"
                    );
                  }
                }
              );
            }
          }
        }
      });
    },
    apiGetCourseState(course_id, key) {
      getCoursesState({
        course_ids: course_id,
      }).then((res) => {
        if (res.code === 1 && res.data?.length) {
          let { live_state, lesson_id, unit_id } = res.data[0] || {};
          if (key === "courseInfo") {
            this[key] = {
              ...this[key],
              live_state,
              livingLessonInfo: {
                lesson_id,
                unit_id,
              },
            };
          } else {
            this[key] = {
              ...this[key],
              ...res.data[0],
            };
          }
        }
      });
    },
    goback() {
      this.$router.push({
        name: "myCourse",
      });
    },
    getQrCodeUrl(url) {
      this.qrCodeUrl = url;
    },
    getPosterUrl(url) {
      this.posterUrl = url;
    },
    handleCopyPageUrl() {
      if (window.isElectron) {
        // let content = `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${this.course_id}`;
        clipboard(this.courseDetailUrl, () => {
          this.$showToast("已复制课程链接，粘贴即可分享");
          this.isShowShare = false;
        });
      } else {
        copyPageUrl("", this.courseDetailUrl);
        this.isShowShare = false;
      }
    },
    handleShare(type) {
      console.log(this.posterUrl);
      if (type === "wechat") {
        this.selectShare = {
          type: "wechat",
          title: "微信",
          content: "扫描二维码，将课程分享给微信好友吧。",
        };
      } else if (type === "QQ") {
        this.selectShare = {
          type: "QQ",
          title: "QQ",
          content: "扫描二维码，将课程分享给QQ好友吧。",
        };
      } else if (type === "space") {
        this.selectShare = {
          type: "space",
          title: "QQ空间",
          content: "扫描二维码，将课程分享到QQ空间吧。",
        };
      } else if (type === "circle") {
        this.selectShare = {
          type: "circle",
          title: "朋友圈",
          content: "扫描二维码，将课程分享到朋友圈吧。",
        };
      } else if (type === "weibo") {
        shareSdk("weibo", {
          url: this.courseDetailUrl, // 分享地址
          title: this.courseInfo.course_name, // 分享标题
          pic: this.courseInfo.cover_url,
        });
      } else if (type === "xhs") {
        if (!this.posterUrl) {
          this.$message.error("海报正在生成中，请稍后重试");
          return;
        }
        shareSdk("xhs", {
          shareInfo: {
            type: "normal", // 必填，笔记类型 'video' | 'normal'
            // title: "测试标题", // 笔记标题
            content: `速看！这门内容充实，讲解精彩的课程【${this.courseInfo.course_name}】，可别错过了！扫描二维码，魔果云课看好课！`, // 笔记正文
            images: [this.posterUrl], // 图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文
          },
          fail: (e) => {
            console.log(e);
            // 调用失败时执行的回调函数
          },
        });
      }
    },
    onShowSharePopover() {
      if (!this.posterUrl) {
        this.$refs.poster.checkLoad();
      }
    },
    handleShareBack() {
      this.selectShare = {
        type: "",
      };
    },
    handlePageLoading(val) {
      this.pageLoading = val;
    },
    dealValidityType(item) {
      if (item.validity_type === 1) {
        return `至 ${moment(item.end_validity * 1000).format(
          "YYYY年MM月DD日"
        )}`;
      } else if (item.validity_type === 2) {
        return `至${moment(item.end_validity * 1000).format(
          "YYYY年MM月DD日 HH:mm:ss"
        )}`;
      } else {
        return "永久有效";
      }
    },
    apiGetOrganization(id) {
      getOrganization({ org_id: id }).then((res) => {
        if (res.code === 1 && res.data) {
          this.orgInfo = res.data;
        }
      });
    },
    apiGetCourseDetail() {
      let params = {
        course_id: this.course_id,
      };
      getCourseDetail(params).then((res) => {
        if (res.code === 1) {
          // 获取机构信息
          this.apiGetOrganization(res?.data?.org_id);
          // 获取机构推荐课程
          this.apiGetOrganizationHome(res?.data?.org_id);
          // 获取课程直播状态
          this.apiGetCourseState(this.course_id, "courseInfo");
          this.localSavePage(res.data);
          this.courseInfo = this.handleCourseInfo(res.data || {});
          this.havePrivateLesson();
        } else if (res.code === 40000) {
          // 未购买
          this.$chiralAutoMessage(`未购买该课程，即将跳转商品详情页~`, 2000);
          setTimeout(() => {
            this.$router.push(`/product-detail/${this.course_id}`);
          }, 2000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCourseInfo(data) {
      if (data?.assistant?.id) {
        EventBus.$emit("hideCourseHelper", true);
      }
      if (data.unit_list && data.unit_list.length) {
        data.unit_list.forEach((unit) => {
          if (unit.lesson_list && unit.lesson_list.length) {
            unit.lesson_list.forEach((lesson) => {
              if (lesson.lesson_type === 2) {
                // 直播课状态处理
                this.handleLiveStatus(lesson);
                // 处理直播间状态
                this.handleRoomStatus(lesson);
                // 提示信息处理
                this.handleLiveTips(lesson);
              }
            });
          }
        });
      }
      // 私教列表
      if (data?.private_unit_list?.length) {
        data.private_unit_list.forEach((unit) => {
          if (unit?.lesson_list?.length) {
            let lessonList = unit?.lesson_list.filter(
              (lesson) => lesson.lesson_type === 4
            );
            lessonList.forEach((lesson) => {
              if (lesson.lesson_type === 4) {
                // 直播课状态处理
                this.handleLiveStatus(lesson);
                // 处理直播间状态
                this.handleRoomStatus(lesson);
                // 提示信息处理
                this.handleLiveTips(lesson);
                // 老师列表
                let arr = [];
                (lesson?.assistant || []).forEach((assistant) => {
                  arr.push(assistant.org_nickname);
                });
                lesson.teachers = arr.join("、");
              }
            });
            unit.lesson_list = lessonList;
          }
        });
      }
      return data;
    },
    // 处理视频时长
    handleDuration(duration) {
      if (duration) {
        const hours = Math.floor(duration / 3600); // 计算小时
        const minutes = Math.floor((duration % 3600) / 60); // 计算分钟钟
        let str = "";
        if (hours) {
          str += `${hours}小时`;
        }
        if (minutes) {
          str += `${minutes}分钟`;
        }
        return str;
      } else {
        return "";
      }
    },
    // 处理直播间状态
    handleRoomStatus(item) {
      let { room_start_time, room_end_time } = item;
      if (room_start_time > 0 && !room_end_time) {
        item.roomStatus = 2;
        item.roomStatusText = "上课中";
      } else if (room_end_time > 0) {
        item.roomStatus = 3;
        item.roomStatusText = "已下课";
      } else {
        item.roomStatus = 1;
        item.roomStatusText = "未开始";
      }
    },
    handleLiveStatus(item) {
      let begin = item.live_start_time;
      let end = item.live_end_time;
      let now = new Date().getTime();
      // 可提前进入
      if (item.first_join_time) {
        begin = begin - item.first_join_time * 60;
      }
      if (end * 1000 < now) {
        // 已结束
        item.status = 3;
      } else if (begin * 1000 > now) {
        // 未开始
        item.status = 1;
      } else {
        // 已开始
        item.status = 2;
      }
      if (item.room_end_time > 0) {
        // 直播已经结束
        item.status = 3;
      }
    },
    // 直播课提示信息
    handleLiveTips(lesson) {
      if (lesson.record_url && lesson.is_record === 1) {
        lesson.liveStatus = 1;
        lesson.tips = "观看视频";
      } else if (lesson.roomStatus === 3 && lesson.is_record === 1) {
        lesson.liveStatus = 2;
        lesson.tips = "回放生成中";
      } else if (lesson.status === 2 || lesson.roomStatus === 2) {
        // 直播间开始上课|到后台设置的课程开始时间
        lesson.liveStatus = 3;
        lesson.tips = "进入教室";
      } else if (lesson.status === 1 && lesson.first_join_time) {
        lesson.liveStatus = 4;
        lesson.tips = `提前${lesson.first_join_time}分钟才可进入`;
      }
    },
    havePrivateLesson() {
      let length = this.courseInfo?.private_unit_list?.length;
      let data = this.tabList.find((tab) => {
        return tab.key === "private";
      });
      if (!data && length) {
        this.tabList.splice(1, 0, { name: "私教课", key: "private" });
      }
      this.courseInfo.havePrivateLesson = length;
    },
  },
  computed: {
    ...mapGetters(["user"]),
    haveLastLearningRecord() {
      let lastLesson =
        JSON.parse(localStorage.getItem("vuex"))?.learningRecord?.lastLesson ||
        {};
      if (lastLesson?.[this.user?.user_id]?.[this.course_id]?.lesson_id) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.lastStudyLesson =
          lastLesson?.[this.user?.user_id]?.[this.course_id];
        return true;
      } else {
        return false;
      }
    },
  },
  components: {
    File,
    "lesson-list": LessonList,
    CreateQrCode,
    Poster,
    OrgCard,
    DownloadArea,
    RecommendCourse,
    CourseHelper,
  },
};
</script>

<style lang="scss" scoped>
.course-detail {
  display: flex;
  flex-direction: column;
  .back-area {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: var(--text-secondary, #515350);
    line-height: 1;
    margin-bottom: 12px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
    cursor: pointer;
  }
  .page-cont-wrap {
    border-radius: 24px;
    margin-bottom: 30px;
  }
  // 课程信息
  .course-crad {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 24px;
    background: var(--card-bg, #fff);
    padding: 16px;
    margin-bottom: 12px;
    .card-operate-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .card-operate {
      display: flex;
      align-items: center;
      button {
        margin-left: 12px;
      }
    }
    .study-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 76px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid #00eb81;
      font-weight: 500;
      font-size: 14px;
      color: #00c89d;
      line-height: 20px;
    }
    .living-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 90px;
      height: 30px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 15px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 18px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 2px;
      }
    }
    .cover-wrap {
      width: 298px;
      height: 168px;
      border-radius: 16px;
      overflow: hidden;
      margin-right: 16px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .course-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 0;
      height: 168px;
      .name {
        margin-bottom: 6px;
        font-weight: 500;
        font-size: 18px;
        color: var(--text-primary, #0d1400);
        line-height: 28px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
      .name-wrap {
        display: flex;
      }
      .share-icon {
        width: 18px;
        height: 28px;
        margin-left: 6px;
      }
      .share-icon img {
        height: 16px;
        width: 16px;
      }
      .lesson-num {
        margin-bottom: 6px;
      }
      .time,
      .lesson-num {
        font-weight: 400;
        font-size: 14px;
        color: var(--text-secondary, #747573);
        line-height: 20px;
      }
    }
    .course-status {
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 28px;
        border-radius: 8px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }
      .status0 {
        background: var(--input-bg, #f5f5f6);
        color: var(--text-secondary, #747573);
      }
      .status1 {
        background: #e8ffea;
        color: #00b42a;
      }
      .status2 {
        background: #e8f7ff;
        color: #219be8;
      }
    }
  }

  .separator-hr {
    width: 1010px;
    height: 1px;
    background: var(--border-color, #efefef);
    border-radius: 12px;
    margin: 0 auto;
  }
  .bottom-cont-wrap {
    .course-lesson-cont {
      float: left;
    }
    .org-cont {
      width: 380px;
      float: right;
    }
    &::after {
      content: "";
      height: 0;
      display: block;
      clear: both;
      visibility: hidden;
    }
  }

  .course-lesson-cont {
    width: 646px;
    background: var(--card-bg, #ffffff);
    border-radius: 18px;
    overflow: hidden;
    padding: 0 18px;
    margin-right: 24px;
  }

  .org-cont {
    flex: 1;
  }

  ::v-deep .org-card {
    width: 100%;
    height: 87px;
    padding: 0 18px;
    .logo {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .org-info {
      height: 50px;
    }
    .desc {
      -webkit-line-clamp: 1;
    }
  }

  .tabs-wrap {
    display: flex;
    padding: 7px 0 14px 22px;
    li {
      font-weight: 400;
      font-size: 16px;
      color: var(--text-secondary, #515350);
      line-height: 22px;
      padding: 6px;
      margin-right: 43px;
      cursor: pointer;
    }
    .active {
      position: relative;
      font-weight: 600;
      color: var(--text-primary, #0d1400);
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 16px;
        height: 3px;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        border-radius: 2px;
      }
    }
  }

  // 单元信息
  .unit-wrap {
    margin-bottom: 15px;
  }
  .unit-name {
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 14px;
  }
  .lesson-card {
    font-size: 14px;
    display: flex;
    align-items: center;
    background: var(--card-bg, #fff);
    margin-bottom: 2px;
    padding: 15px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }
    .lesson-info {
      flex: 1;
      .status {
        margin-top: 15px;
      }
      .info-wrap {
        display: flex;
        .name {
          width: 250px;
          padding-right: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .time {
          width: 300px;
        }
        .teacher {
          width: 150px;
        }
        // justify-content: space-around;
      }
    }
    .operate {
      width: 150px;
      display: flex;
      justify-content: center;
    }
  }
}
// 客户端
.electron-course-detail.course-detail {
  .page-cont-wrap {
    padding: 12px;
    margin-bottom: 30px;
  }
  // 课程信息
  .course-crad {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    .cover-wrap {
      width: 200px;
      height: 110px;
      margin-right: 10px;
      border-radius: 16px;
    }
    .course-info {
      height: 110px;
      .name {
        margin-bottom: 3px;
        font-size: 16px;
        line-height: 28px;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }
      .lesson-num {
        margin-bottom: 4px;
      }
      .time,
      .lesson-num {
        font-size: 12px;
        line-height: 14px;
      }
    }
    .course-status {
      span {
        width: 51px;
        height: 24px;
        border-radius: 6px;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }

  .separator-hr {
    width: 100%;
  }

  .tabs-wrap {
    display: flex;
    padding: 5px 0 7px 35px;
    li {
      font-size: 14px;
      line-height: 20px;
      padding: 6px;
      margin-right: 40px;
    }
  }
  ::v-deep .course-helper-wrap {
    right: 20px;
  }
}
.share-box {
  --share-list-text: var(--mg-text-primary, #0d1400);
  --share-list-secondary-text: var(--mg-text-secondary, #515350);
  --share-list-hover-bg: var(--mg-control-hover-bg, #f6f8fc);
  --share-list-divider: var(--mg-border-subtle, #f2f3f5);

  .share-list {
    padding: 9px 8px 5px 8px;
    .share-item {
      width: 174px;
      height: 38px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        background: var(--share-list-hover-bg);
      }
      img {
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-right: 7px;
      }
      span {
        font-size: 14px;
        color: var(--share-list-text);
        line-height: 20px;
      }
      &.copy {
      }
    }
    .divider {
      width: 173px;
      height: 1px;
      background: var(--share-list-divider);
      margin: 7px 0 3px 0;
    }
  }
  .share-content {
    width: 190px;
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 14px;
      margin-left: 19px;
      img {
        cursor: pointer;
        width: 6px;
        height: 9px;
        margin-right: 6px;
      }
      span {
        font-weight: 400;
        font-size: 16px;
        color: var(--share-list-secondary-text);
        line-height: 22px;
      }
    }
    .qrcode-box {
      margin-top: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tips {
      padding: 0 13px 21px 16px;
      margin-top: 22px;
      font-weight: 400;
      font-size: 16px;
      color: var(--share-list-text);
      line-height: 22px;
      text-align: center;
    }
  }
}

// h5
.course-detail.h5-course-detail {
  min-width: 1050px;
}
</style>
<style>
.el-loading-spinner {
  font-size: 40px !important;
  z-index: 99;
}
.el-loading-spinner .el-loading-text {
  font-size: 15px !important;
  font-weight: 700 !important;
}
.share-popover {
  padding: 0;
  border-radius: 12px;
}
</style>
